import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { checkUserGroup } from '../utils/authUtils';

/**
 * Wraps Pro-only routes. Must be used *inside* a ProtectedRoute wrapper so the
 * user is already confirmed signed in.
 *
 * Non-Pro users are bounced to /pricing with a flash-state flag so the Pricing
 * page can show a contextual upsell banner.
 *
 * UI-level check only. Real authorization is enforced server-side on every
 * Pro-gated API call via is_pro_user() in the Lambda.
 */
export default function ProRoute({ children }) {
    const [state, setState] = useState({ loading: true, isPro: false });

    useEffect(() => {
        let cancelled = false;
        checkUserGroup()
            .then(({ isPro }) => {
                if (!cancelled) setState({ loading: false, isPro });
            })
            .catch(() => {
                if (!cancelled) setState({ loading: false, isPro: false });
            });
        return () => { cancelled = true; };
    }, []);

    if (state.loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
                <CircularProgress />
            </Box>
        );
    }
    if (!state.isPro) {
        return <Navigate to="/pricing" replace state={{ proRequired: true }} />;
    }
    return children;
}
